export const ErrorCodes = {
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  USER_LOGIN_NOT_VERIFIED: "USER_LOGIN_NOT_VERIFIED",
  WALLET_NOT_SUPPORTED: "WALLET_NOT_SUPPORTED",

  USER_REJECTED_TRANSACTION: "USER_REJECTED_TRANSACTION",
  TRANSACTION_ERROR: "TRANSACTION_ERROR",

  USER_REJECTED_SIGNATURE: "USER_REJECTED_SIGNATURE",
  SIGNATURE_ERROR: "SIGNATURE_ERROR",

  AUTH_BAD_AUTHENTICATION: "AUTH_BAD_AUTHENTICATION",
  AUTH_ROLE_NOT_FOUND: "AUTH_ROLE_NOT_FOUND",
  AUTH_USER_ALREADY_REGISTERED: "AUTH_USER_ALREADY_REGISTERED",
  AUTH_USER_NOT_FOUND: "AUTH_USER_NOT_FOUND",
  AUTH_BAD_INPUT_PARAMETER: "AUTH_BAD_INPUT_PARAMETER",
  AUTH_BAD_TYPE_RENDERED: "AUTH_BAD_TYPE_RENDERED",
  AUTH_COMMON_ERROR: "AUTH_COMMON_ERROR",
  AUTH_BAD_AUTH_CODE_TYPE: "AUTH_BAD_AUTH_CODE_TYPE",
  AUTH_RATE_LIMIT_EXCEEDED: "AUTH_RATE_LIMIT_EXCEEDED",

  VOTE_SAFE_TRANSACTION_ALREADY_PENDING: "VOTE_SAFE_TRANSACTION_ALREADY_PENDING",
  VOTE_SAFE_PROPOSAL_IN_PROGRESS: "VOTE_SAFE_PROPOSAL_IN_PROGRESS",
} as const

export type ErrorCodes = (typeof ErrorCodes)[keyof typeof ErrorCodes]
